import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/data.service';
import { KeycloakService } from 'keycloak-angular';
import { environment } from "../../../environments/environment";

@Component({
  selector: 'app-mfooldal',
  templateUrl: './fooldal.component.html',
  styleUrls: ['./fooldal.component.scss'],
})
export class mFooldalComponent implements OnInit {

  userMetadata
  user$
  protected readonly environment = environment;

  constructor(private http: HttpClient, private data:DataService,public keycloak: KeycloakService) {}

  async ngOnInit() {
    this.user$ = await this.keycloak.loadUserProfile();
    this.userMetadata = await this.data.getFromStorage("userMetadata")
  }

}
